export default {
  placeholder: {
    en: 'Your friend’s email',
  },
  buttonTitle: {
    en: 'Send',
  },
}
